import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative mt-4"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.sttResultFinal.length)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_TableV2, {
            data: _ctx.sttResultFinal,
            columns: _ctx.columns,
            borderTop: false,
            pagination: _ctx.pagination,
            "is-hard-pagination": true,
            "is-quick-search": true,
            "is-sorting": true,
            "pagination-style": "v2",
            customButtonAction: _ctx.customButton,
            autoHeight: "",
            isPinnedScrollBottom: false
          }, {
            "top-left-table": _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["data", "columns", "pagination", "customButtonAction"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowPopupDelete)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onSubmit: _ctx.popupModalData?.success?.action,
          onClose: _ctx.popupModalData?.cancel?.action,
          title: _ctx.popupModalData.title,
          message: _ctx.popupModalData.message,
          image: _ctx.popupModalData.image,
          textSuccess: _ctx.popupModalData?.success?.text,
          textCancel: _ctx.popupModalData?.cancel?.text,
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}